import { MEDIA_TYPES, SORT_OPTIONS } from './consts';

export const initialFilters = () => ({
  licenseType: 'all',
  orientations: undefined,
  numberOfPeople: undefined,
  ageOfPeople: undefined,
  ethnicity: undefined,
  formatAvailable: [],
  duration: undefined,
  excludeNudity: true,
  color: undefined,
});

export const getNewList = () => ({
  items: [],
  page: 0,
  total: 0,
  assetsInProgress: false,
  hasMoreAssets: false,
  selected: undefined,
});

export default () => ({
  __record: 'IStockRecord',
  account: {
    firstName: '',
    lastName: '',
  },
  isSignedIn: false,
  isAuthInProgress: false,
  searchTerm: '',
  mediaType: MEDIA_TYPES.IMAGES,
  list: getNewList(),
  sortOrder: SORT_OPTIONS[0],
  isFiltersPanelOpen: false,
  areFiltersSet: false,
  filters: initialFilters(),
  selectedProduct: undefined,
  selectedFormat: undefined,
  purchasedUrl: undefined,
  purchaseInProgress: false,
  products: [],
  homePageItems: [],
  downloads: [],
  shouldDownloadsBeRefreshed: true,
});
